import axios from 'axios'

export default class {
    salvar (corretora) {
        return axios.put('api/corretoras/', corretora)
    }
}